export const TAB_ID = 'tab';
export const SEARCH_ID = 'q';
